import React from 'react';
import { Layer, Source } from 'react-map-gl/mapbox';
import { MapboxTrip } from '../../../../types/Mapbox';

interface Props {
  geometry: MapboxTrip['geometry'];
}

export default function EventRouteLayer({ geometry }: Props) {
  return (
    <Source
      id="event-route"
      type="geojson"
      data={{
        type: 'Feature',
        properties: {},
        geometry,
      }}
    >
      {/* White outline behind the route to improve contrast */}
      <Layer
        id="route-outline"
        type="line"
        layout={{
          'line-cap': 'round',
          'line-join': 'round',
        }}
        paint={{
          'line-color': '#ffffff',
          'line-width': 10,
          'line-opacity': 0.95,
        }}
      />

      {/* Primary optimized route */}
      <Layer
        id="route"
        type="line"
        layout={{
          'line-cap': 'round',
          'line-join': 'round',
        }}
        paint={{
          'line-color': '#1976d2',
          'line-width': 6,
          'line-opacity': 1,
        }}
      />

      {/* Direction arrows rendered along the route */}
      <Layer
        id="route-arrows"
        type="symbol"
        layout={{
          // Place symbols following the line geometry
          'symbol-placement': 'line',
          // Triangle arrow glyph
          'text-field': '▶',
          // Slightly larger arrows for better visibility
          'text-size': ['interpolate', ['linear'], ['zoom'], 8, 16, 14, 26, 18, 36],
          // Space arrows a little further apart
          'symbol-spacing': ['interpolate', ['linear'], ['zoom'], 8, 70, 14, 120, 18, 200],
          // Rotate arrows with route direction
          'text-keep-upright': false,
        }}
        paint={{
          // White arrow with blue outline tends to stand out more
          'text-color': '#ffffff',
          'text-halo-color': '#1976d2',
          'text-halo-width': 2.5,
        }}
      />
    </Source>
  );
}
